import axios from "@/request";
import qs from "qs";

export default {
  /* 操作权限检查 */
  async check(params: any) {
    return axios.get("stadium-estimate/check", { params });
  },
  /* 编辑场馆信息 */
  async edit(params: any) {
    return axios.post("stadium-estimate/edit", qs.stringify(params));
  },
  /* 提交评估 */
  async submit(params: any) {
    return axios.post("stadium-estimate/submit", qs.stringify(params));
  },
}
